import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Spin } from "antd";

import Swal from "sweetalert2";

import ApiService_mall from "../../../apis/ApiService_mall";
import { handleIsMallUserWithPartners } from "../LoginUitls";

const api = new ApiService_mall();

const KakaoCall = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const user = useSelector((state) => state.auth.user);

	// const [backPage, setBackPage] = useState(null);
	// const [guestUserId, setGuestUserId] = useState(null);
	const [code, setCode] = useState(null);
	// const [userInfo, setUserInfo] = useState(null);

	useEffect(() => {
		if (!window.Kakao?.isInitialized()) {
			// 두번째 step 에서 가져온 javascript key 를 이용하여 initialize
			window.Kakao?.init(process.env.REACT_APP_KAKAO_KEY);
		}

		// const backPage = localStorage.getItem("login-before-page");
		// const guestUserId = localStorage.getItem("guest_user_id");
		// setBackPage(backPage);
		// setGuestUserId(guestUserId);
	}, []);

	useEffect(() => {
		// setCode(history.query?.code);
		setCode(history.location.search?.replaceAll("?code=", ""));
	}, [history.location]);

	useEffect(() => {
		console.log(code, user);
		if (code) {
			if (user) {
				history.push("/dashboard");
			} else {
				kakaoToken();
			}
		} else {
			// history.replace("/");
		}
	}, [code]);

	const kakaoToken = async () => {
		// setIsLoading(true);
		let param = {
			grant_type: "authorization_code",
			client_id: "e24e92c52be719943a33f611d6264924",
			redirect_uri: `${process.env.REACT_APP_HOST}/user/sns/kakao`,
			code: code,
		};
		const res = await api.kakaoToken(param);

		console.log(param, res);

		if (res.status === 200) {
			window.Kakao.Auth.setAccessToken(res.data.access_token);
			window.Kakao.API.request({
				url: "/v2/user/me",
				success: async (response) => {
					let kakaoAccount = response.kakao_account;
					// let replacePhone = kakaoAccount.phone_number
					//   ?.replace("-", "")
					//   .replace("-", "")
					//   .replace("+82 ", "0");
					//SNS 가입여부 판단
					let param = {
						provider: "kakao",
						provider_id: response.id,
						// phone: kakaoAccount.phone_number ? "" : null,
					};
					let res = await api.snsValid(param);
					if (res.data.code === 200) {
						const result = res.data.result;

						//가입 시 로그인 처리
						if (result.is_valid === true) {
							//RN 통신 로그인 되는 순간 기기값 요청
							// const param = {
							//     type: "TOKEN",
							//     accessToken: res.data.result.tokenDto.accessToken,
							// };
							// util.sendRNMessage(param);

							localStorage.removeItem("admin:accessToken");
							localStorage.removeItem("admin:refreshToken");

							localStorage.setItem(
								"admin:accessToken",
								res.data.result.tokenDto.accessToken
							);
							localStorage.setItem(
								"admin:refreshToken",
								res.data.result.tokenDto.refreshToken
							);
							await handleIsMallUserWithPartners(
								res.data.result.user,
								dispatch,
								history
							);
							// history.replace("/dashboard");
						} else {
							if (result.is_user_valid === true) {
								// window.alert(
								//     "이미 회원가입이 된 사용자입니다. 아이디 찾기를 진행해주세요."
								// );
								Swal.fire({
									customClass: "alert-custom",
									text: "이미 회원가입이 된 사용자입니다. 아이디 찾기를 진행해주세요.",
									confirmButtonText: "확인",
									// confirmButtonColor: "#212529",
									// icon: "warning"
								});
								// setIsLoading(false);
							} else {
								Swal.fire({
									customClass: "alert-custom",
									text: `회원가입이 필요합니다.`,
									confirmButtonText: "확인",
									// confirmButtonColor: "#212529",
								}).then(() => {
									let snsUserInfo = {
										provider: "kakao",
										provider_id: response.id,
										gender: kakaoAccount.gender,
										phone_number: kakaoAccount.phone_number,
										birthday: kakaoAccount.birthday,
										birthyear: kakaoAccount.birthyear,
										profile_nickname: kakaoAccount.profile.nickname,
									};
									// dispatch(setSnsUserInfo(snsUserInfo));
									sessionStorage.setItem(
										"snsUserInfo",
										JSON.stringify(snsUserInfo)
									);
									history.push(`/user/signup`);
									// history.push(`/user/register/info`);
									// setIsLoading(false);
								});
							}
						}
					} else {
						// window.alert(
						//     "카카오톡 로그인 연동이 실패되었습니다. 다시 시도해주세요."
						// );
						// history.replace(`/login`);

						Swal.fire({
							text: "카카오톡 로그인 연동이 실패되었습니다. 다시 시도해주세요.",
							// text: "카카오톡 로그인 연동이 실패되었습니다. 다시 시도해주세요.\nKakao.API.request res.data.code != 200",
							confirmButtonText: "확인",
							// confirmButtonColor: "#212529",
							// icon: "error"
						}).then(() => {
							history.replace(`/login`);
						});
						// setIsLoading(false);
					}
				},
				fail: function () {
					// window.alert("카카오 연동이 실패하였습니다. 다시 시도해주세요.");
					Swal.fire({
						text: "카카오톡 로그인 연동이 실패되었습니다. 다시 시도해주세요.",
						// text: "카카오톡 로그인 연동이 실패되었습니다. 다시 시도해주세요.\nKakao.API.request fail 실행",
						confirmButtonText: "확인",
						// confirmButtonColor: "#212529",
						// icon: "error"
					});
					if (user) {
						localStorage.removeItem("admin:accessToken");
						localStorage.removeItem("admin:refreshToken");

						// dispatch(setUser(null));
						// setIsLoading(false);
						// if (backPage) {
						// 	if (backPage === "/") {
						// 		history.replace(backPage, undefined, { shallow: true });
						// 	} else {
						// 		history.replace(backPage);
						// 	}
						// } else {
						history.replace("/");
						// }
					} else {
						history.push(`/login`);
					}
					// history.push(`/login`)
					// setIsLoading(false);
				},
			});
		} else {
			// window.alert("카카오 연동이 실패하였습니다. 다시 시도해주세요.");

			Swal.fire({
				// text: `카카오톡 로그인 연동이 실패되었습니다. 다시 시도해주세요.\nredirect_uri = ${process.env.NEXT_PUBLIC_APP_HOST}/user/sns/kakao\ncode = ${code}\nmsg = ${res}\nres = ${JSON.parse(res.response)}\ndata = ${JSON.parse(res.response.data)}`,
				text: "카카오톡 로그인 연동이 실패되었습니다. 다시 시도해주세요.",
				confirmButtonText: "확인",
				// confirmButtonColor: "#212529",
				// icon: "error"
			}).then(() => {
				history.replace(`/login`);
			});
			if (user) {
				localStorage.removeItem("admin:accessToken");
				localStorage.removeItem("admin:refreshToken");

				// dispatch(setUser(null));
				// setIsLoading(false);
				// if (backPage) {
				// 	if (backPage === "/") {
				// 		history.replace(backPage, undefined, { shallow: true });
				// 	} else {
				// 		history.replace(backPage);
				// 	}
				// } else {
				// 	history.replace("/");
				// }
				history.replace("/");
			} else {
				history.push(`/login`);
				// history.push(`/user/login/main`);
			}
			// history.push(`/login`)
			// setIsLoading(false);
		}
	};

	/**
	 * 로그인 시 쿼리 확인
	 */
	// const loginLog = async (user) => {
	// 	let log = sessionStorage.getItem("query");
	// 	if (log) {
	// 		let param = {
	// 			log: log,
	// 			created_by: user.id,
	// 			created_at: new Date(),
	// 		};
	// 		await api.queryLogCreate(param);
	// 	}
	// };

	return (
		<div
			style={{
				margin: "auto",
				width: "100%",
				position: "fixed",
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				zIndex: 999,
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				backgroundColor: "white",
			}}
		>
			<Spin size={"large"} />
		</div>
	);
};

export default KakaoCall;
